import React  from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import { I18n } from 'react-redux-i18n';
import cx from 'classnames';

// Utils.
import { isFreeUser, isIOSApp } from 'utils';

// Styles.
import styles from './styles.module.scss';

const HeaderMenuMain = (props) => {

  const onClickUserMenuUpgrade = () => {
  };

  const onClickUserMenuAnalytics = () => {
  };

  const onClickUserMenuLMS = () => {
  };

  const onClickUserMenuDataSources = () => {
  };

  const { locationPath, userState, isDemoScrolling, isAuthenticated, theme } = props;
  const isFreeUserStatus = isFreeUser(userState);

  if(!isAuthenticated) {
    return null
  }

  return (
    <div className={styles.availableMenu}>
      {isFreeUserStatus &&
        <div key="header-menu-item-upgrade" id="menuItemUpgrade" className={cx(styles.menuItem, styles.menuItemUpgrade, { [ styles.isDemoScrolling ]: isDemoScrolling })} onClick={onClickUserMenuUpgrade}>
          <LinkContainer to="/payment">
            <div className={cx(styles.menuItemText)}>{I18n.t('Upgrade')}</div>
          </LinkContainer>
        </div>
      }
      <div key="header-menu-item-dashboard" id="menuItemDashboard" className={cx(styles.menuItem, styles.menuItemDashboard, { [styles.active]: locationPath.indexOf('dashboard') !== -1 }, { [styles.isDemoScrolling]: isDemoScrolling })} onClick={onClickUserMenuAnalytics}>
        <LinkContainer to="/dashboard">
          <div className={cx(styles.menuItemText, {[styles.themeDark]: theme === 'ink'})}>Dashboard</div>
        </LinkContainer>
      </div>
      <div key="header-menu-item-lms" id="menuItemLMS" className={cx(styles.menuItem, styles.menuItemLMS, { [styles.active]: locationPath.indexOf('lms') !== -1 }, { [styles.isDemoScrolling]: isDemoScrolling })} onClick={onClickUserMenuLMS}>
        <LinkContainer to="/lms">
          <div className={cx(styles.menuItemText, {[styles.themeDark]: theme === 'ink'})}>Academy</div>
        </LinkContainer>
      </div>
    </div>
  );

};

export default HeaderMenuMain;
